import React, { createContext, useContext, useState } from 'react'

export type InfoPanelState = {
  isShown: boolean
  render: JSX.Element
  title?: string
}

type InfoPanelContextType = {
  infoPanelState: InfoPanelState
  setInfoPanelState: React.Dispatch<React.SetStateAction<InfoPanelState>>
}

const InfoPanelContext = createContext<InfoPanelContextType>({
  infoPanelState: {
    isShown: false,
    render: <></>,
    title: '',
  },
  setInfoPanelState: () => null,
})

export function InfoPanelProvider({
  children,
}: {
  readonly children:
    | NonNullable<React.ReactNode>
    | Array<NonNullable<React.ReactNode>>
}): JSX.Element {
  const [infoPanelState, setInfoPanelState] = useState<InfoPanelState>({
    isShown: false,
    render: <div></div>,
    title: '',
  })

  return (
    <InfoPanelContext.Provider
      value={{
        infoPanelState,
        setInfoPanelState,
      }}
    >
      {children}
    </InfoPanelContext.Provider>
  )
}

export const useInfoPanelContext = (): InfoPanelContextType =>
  useContext(InfoPanelContext)
